import { MailOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import SendEmailContent from 'automations/components/Nodes/SendEmailContent';
import { type SendEmailNodeType } from 'automations/types/nodeSchemas/actionNodes';
import { nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type ActionNodeReturnProps } from './useActionNodeConfig';

export default function useSendEmail(node: NodeProps<SendEmailNodeType>): ActionNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.SendEmailActionNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <SendEmailContent node={node} />, [node]);

  return {
    icon: MailOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
  };
}
